import ApiService from "./api.service";
import {
  TokenService
} from "./storage.service";

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const User = {
  /**
   * Login the user and store the access token to TokenService.
   *
   * @returns access_token
   * @throws AuthenticationError
   **/
  login: async function (username, password, remember = false) {
    try {
      const response = await ApiService.post("/login", {
        username: username,
        password: password
      });

      TokenService.saveToken(response.data.access_token, remember);
      TokenService.saveRefreshToken(response.data.refresh_token, remember);
      ApiService.setHeaderAuth();

      ApiService.mount401Interceptor();

      return response.data.access_token;
    } catch (error) {
      throw new AuthenticationError(error.response.status, error.response.data.message);
    }
  },

  /**
   * Refresh the access token.
   **/
  refreshToken: async function () {
    try {
      const response = await ApiService.post("login/refresh", {
        refresh_token: TokenService.getRefreshToken()
      });

      TokenService.saveToken(response.data.access_token);
      TokenService.saveRefreshToken(response.data.refresh_token);
      // Update the header in ApiService
      ApiService.setHeaderAuth();

      return response.data.access_token;
    } catch (error) {
      throw new AuthenticationError(error.response.status, error.response.data.message);
    }
  },

  /**
   * Logout the current user by removing the token from storage.
   *
   * Will also remove `Authorization Bearer <token>` header from future requests.
   **/
  logout() {
    // Remove the token and remove Authorization header from Api Service as well
    TokenService.removeToken();
    TokenService.removeRefreshToken();
    ApiService.removeHeaderAuth();

    // NOTE: Again, we'll cover the 401 Interceptor a bit later.
    ApiService.unmount401Interceptor();
  },
  /**
   * Load user
   */
  load: async function () {
    try {
      let response = await ApiService.get("/user", {});
      return response.data;
    } catch (error) {
      if (error.response.status === 401) {
        throw new AuthenticationError(error.response.status, error.response.data.message);
      }
    }
  },

  /** 
   * Update my info 
   */
  update: async function (data) {
    let response = await ApiService.put("/user", data, "The profile has been updated");
    return response.data;
  }
};

export default User;

export {
  User,
  AuthenticationError
};